import {AxiosResponse} from 'axios'
import {corporateApi} from '../../../../setup/axios/CorporateApi'
import {ApiResponse, PageResponse} from '../../../../shared/models/ApiModels'
import {filterParams} from '../application/Api'
import {IListFilters} from '../shared/SearchFilterBar'
import {ICandidateModel, ICandidateUpdateRequest} from './CandidateModel'

const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')
const CANDIDATE_URL = `${API_URL}api/v1/candidate/`

/** Aday havuzu; son başvuru yapan üstte */
export function searchCandidates(
  filters: Partial<IListFilters>,
  page = 0,
  size = 10
): Promise<AxiosResponse<ApiResponse<PageResponse<ICandidateModel>>>> {
  return corporateApi.get(`${CANDIDATE_URL}search`, {
    params: {
      ...filterParams({q: filters.q, jobId: filters.jobId, tagId: filters.tagId}),
      page,
      size,
      sort: 'lastApplicationDate,desc',
    },
  })
}

/** Aday künyesi (başvurularıyla) */
export function getCandidate(id: string): Promise<AxiosResponse<ApiResponse<ICandidateModel>>> {
  return corporateApi.get(`${CANDIDATE_URL}getById/${id}`)
}

export function updateCandidate(
  id: string,
  request: ICandidateUpdateRequest
): Promise<AxiosResponse<ApiResponse<ICandidateModel>>> {
  return corporateApi.patch(`${CANDIDATE_URL}update/${id}`, request)
}

export function deleteCandidate(id: string) {
  return corporateApi.delete(`${CANDIDATE_URL}delete/${id}`)
}

/** Havuz özelliğinden önce gelmiş başvuruları havuza aktarır; aktarılan sayıyı döner */
export function syncApplicationsToPool(): Promise<AxiosResponse<ApiResponse<number>>> {
  return corporateApi.post(`${CANDIDATE_URL}syncApplications`)
}
